import { SVGProps } from 'react';

const LaptopIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="20"
    viewBox="0 0 25 20"
    fill="currentColor"
    {...props}
  >
    <g clipPath="url(#clip0_700_714)">
      <path
        d="M5 1.25C3.62109 1.25 2.5 2.37109 2.5 3.75V13.75H5V3.75H20V13.75H22.5V3.75C22.5 2.37109 21.3789 1.25 20 1.25H5ZM0.75 15C0.335938 15 0 15.3359 0 15.75C0 17.4062 1.34375 18.75 3 18.75H22C23.6562 18.75 25 17.4062 25 15.75C25 15.3359 24.6641 15 24.25 15H0.75Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_700_714">
        <path d="M0 0H25V20H0V0Z" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export default LaptopIcon;
